import React, { useEffect, useRef, useState} from "react";
import Loading from "components/Loading";
import {OutlinePrimaryBtn, SolidPrimaryBtn, SolidPrimarySubBtn, SolidRedBtn} from "components/button/Button";
import {
    EllipsisTextColumn,
    FlexGrow,
    ListContentWrap,
    PageArticleWrap,
    PageHeaderTitleButtonStyle,
} from "components/layout/Layout";
import {CustomCheckbox, SelectOption} from "components/input/Input";
import styled from "styled-components";
import {
    aesCBCDecrypt,
    aesCBCEncrypt, checkId, checkMobile, checkName, formattedSelectOption, getUserImageUrl,
    handleImageUpload,
    NoTeacherDataText,
    ROLE_TEACHER
} from "../../utils/commonUtils";
import {
    ClassInfo,
    ClassQueryParams, CommonResult,
    ListResult,
    provinceInfo,
    UserInfo, UserPostType,
    UserQueryParams,
    UserSiteInfo
} from "../../type/type";
import {createUserHandler, deleteUserHandler, getClass, getUser, updateUserHandler, userApproval} from "../../api/api";
import {NoDataWithImageText} from "components/NoDataComponent";
import DefaultProfileS from "../../assets/image/common/default_profile_S.svg";
import {colors} from "../../styles/global-styles";
import {RoundBigImage, RoundImageContainer} from "components/common/Image";
import {DefaultModalComponent, ModalPropsInterface, ModalTitle, ModalType} from "components/ModalComponent";
import { RoundIcon } from "components/common/Icon";
import { FlexWrapR, InputWrapC, InputWrapR } from "components/common/CommonLayout";
import { useRecoilValue } from "recoil";
import { selectSiteIdState } from "styles/atoms";

// 테이블 위 버튼 wrap
const JoinNavWrap = styled.nav`
  display:flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`;
const CheckBoxWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-left: auto;
`;

const NoDataWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`
const TableColumn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
  > div {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    &:nth-of-type(6) {
      word-break: auto-phrase;
    }
  }
  .thumbnail-wrap {
    max-height: 5rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &:hover {
    background-color: ${({theme}) => theme.newTheme.table.tableBodyHoverBg};
  }
    .flex-end {
        justify-content: end;
        gap: 0.25rem 0.5rem;
    }
`;

const ImageOneWrap = styled.div`
    aspect-ratio: 1 / 1;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    padding-right: 1rem;
    min-width: 140px;

    .preview-image {
        height: 100%;
        width:100%;
        border-radius: 50%;
    } 
    .carema-icon {
        position: absolute;
        top: 75%;
        left: 70%;
    }  
    .delete-preview-image {
        display: none;
        position: absolute;
        top: 1px;
        right: 1px;
    }
    &:hover {
        cursor: pointer;

        img:not(.cancel-icon),
        label {
            opacity: 0.7;
        }
        .delete-preview-image {
            display: block;
        }
    }
`;

//가로 content
const RowContentWrap = styled.div`
  width: 100%;
  display: flex;
`;

//left content
const RowContentLeftWrap = styled.div`
  width: 22%;
  .file-wrap {
    width:100%;
  }
`;

//right content
const RowContentRightWrap = styled.div`
  width: 78%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem 0.25rem;
`;


interface TeacherListViewerProps{
    teacherList: UserInfo[];
    setIsUpdateAllApproval: (value:boolean) => void;
    waitApproval: number;
    allSelectTeacherCheck: boolean;
    selectTeacherIdList: number[];
    setAllSelectTeacherCheck: (value:boolean) => void;
    handleSelectTeacherId: (teacherId:number) => void;
    handleAllSelectTeacherId: () => void;
    updateApproval: (teacherId:number,approval:number) => void;
    changeRequestTeacherHandler: (teacher:UserInfo) => Promise<void>;
    openModal:(modalType:ModalType) => void;
    handleDeleteTeacher: (userId:number) => void;
}

/**
 * 선생님 테이블 컴포넌트
 * @param teacherList 선생님 정보 리스트
 * @param setIsUpdateAllApproval 일괄 승인 클릭 여부 상태
 * @param waitApproval 승인대기 수
 * @param allSelectTeacherCheck 모든 선생님 ID 체크박스 상태
 * @param selectTeacherIdList 체크 선택된 선생님 ID 체크박스
 * @param setAllSelectTeacherCheck 모든 선생님 ID 체크박스 상태 변경 이벤트
 * @param handleSelectTeacherId 선생님 ID 체크박스 선택 이벤트
 * @param handleAllSelectTeacherId 모든 선생님 ID 체크박스 선택 이벤트
 * @param updateApproval 승인 요청 함수
 * @param changeRequestTeacherHandler 선생님 수정 클릭 시 requestTeacher 업데이트 함수
 * @param openModal 모달 열기 함수
 * @param setSelectUserId 수정, 삭제 클릭 시 userId 저장 함수
 * @param handleDeleteTeacher 선생님 삭제 함수
 * @constructor
 */
const TeacherListViewer:React.FC<TeacherListViewerProps> = ({teacherList,
                                                            setIsUpdateAllApproval,
                                                            waitApproval,
                                                            allSelectTeacherCheck,
                                                            selectTeacherIdList,
                                                            setAllSelectTeacherCheck,
                                                            handleSelectTeacherId,
                                                            handleAllSelectTeacherId,
                                                            updateApproval,
                                                            changeRequestTeacherHandler,
                                                            openModal,
                                                            handleDeleteTeacher}) => {

    
    //승인완료 숨기기 체크박스 상태
    const [allApprovalCheck, setAllApprovalCheck] = useState<boolean>(false);

    /**
     * 일괄 승인 요청
     */
    const updateAllApproval = async () => {

        try{
            if(selectTeacherIdList.length <= 0){
                alert("선택된 선생님이 없습니다.");
                return;
            }

            //선택한 선생님 중 승인 대기인 선생님만 추출
            const approvalTeacherList:UserInfo[] = teacherList.filter((teacher:UserInfo) =>
                selectTeacherIdList.includes(teacher.id) && (teacher.approval === 0 || teacher.approval === 2)
            );

            if(approvalTeacherList.length <= 0){
                alert("선택된 선생님 중 승인 대기인 선생님이 없습니다.");
                return;
            }

            const allRequest = approvalTeacherList.map(async (teacher:UserInfo ) => {
                const res: CommonResult = await userApproval(teacher.id, 1);
            });

            await Promise.all(allRequest);
            alert("승인 요청이 완료되었습니다.");
            setIsUpdateAllApproval(true);
        }
        catch (e) {
            console.error(e);
        }

    }

    useEffect(() => {
        //모든 선생님이 선택되었을때, all 체크박스 체크
        if (teacherList.length > 0 && selectTeacherIdList.length === teacherList.length) {
            setAllSelectTeacherCheck(true);
        } else {
            setAllSelectTeacherCheck(false);
        }
    }, [selectTeacherIdList, setAllSelectTeacherCheck, teacherList]);

    return (
      <ListContentWrap style={{gap: '0.5rem', height: 'calc(100% - 1.25rem - 0.5rem)'}}>
        <JoinNavWrap>
          <p>
            <span>전체: <RoundIcon type="disabled" text={`${teacherList.length}`} /> 건 / </span>
            <span>승인대기: <RoundIcon type="waiting" text={`${waitApproval}`} /> 건</span>
          </p>
          <CheckBoxWrap>
            <CustomCheckbox id="all-approval" type="checkbox"
                            onClick={() => {setAllApprovalCheck(!allApprovalCheck)}} checked={allApprovalCheck}/>
            <label htmlFor="all-approval">승인완료 숨기기</label>
          </CheckBoxWrap>
          <OutlinePrimaryBtn type="button" onClick={updateAllApproval}>
            일괄 승인
          </OutlinePrimaryBtn>
        </JoinNavWrap>
        <div className="list-one-wrap">
          <div className="list-table">
            <div>
              <nav className="list-table-header">
                <FlexWrapR className="w-5" $justifyContent="center" $alignItems="center">
                  <CustomCheckbox type="checkbox"
                                  checked={allSelectTeacherCheck}
                                  onClick={handleAllSelectTeacherId}/>
                </FlexWrapR>
                <div className="w-12">사진</div>
                <FlexGrow className="w-12">이름</FlexGrow>
                <FlexGrow className="w-12">아이디</FlexGrow>
                <FlexGrow className="w-12">담당 반</FlexGrow>
                <div className="w-12">연락처</div>
                <div className="w-20">승인 상태</div>
              </nav>

            {/*선생님 리스트 출력 + approval 정렬 */}
            {teacherList.sort((a, b) => a.approval - b.approval).map((teacher,index)  => {
                //승인완료 숨기기
                if(allApprovalCheck && teacher.approval === 1){
                  return null;
                }

                let approvalText = "";
                let approvalColor = "";

                switch (teacher.approval) {
                  case 0:
                    approvalText = "승인 대기";
                    approvalColor = "text-yellow";
                    break;
                  case 1:
                    approvalText = "승인 완료";
                    approvalColor = "text-gray";
                    break;
                  case 2:
                    approvalText = "승인 거절";
                    approvalColor = "text-red";
                    break;
                }

                return (
                  <TableColumn key={teacher.id}>
                    <FlexWrapR className="w-5" $justifyContent="center" $alignItems="center">
                      <CustomCheckbox type="checkbox"
                                      value={teacher.id}
                                      checked={selectTeacherIdList.includes(teacher.id)}
                                      onClick={() => {
                                          handleSelectTeacherId(teacher.id)
                                      }}/>
                    </FlexWrapR>
                    <RoundImageContainer className="w-12">
                      <RoundBigImage src={teacher.image_url} alt="profile" />
                    </RoundImageContainer>
                    <FlexGrow className="w-12">
                      <EllipsisTextColumn>{aesCBCDecrypt(teacher.name)}</EllipsisTextColumn>
                    </FlexGrow>
                    <FlexGrow className="w-12">
                      <EllipsisTextColumn>{teacher.login_id}</EllipsisTextColumn>
                    </FlexGrow>
                    {/*선생님이 담당하는 반 리스트*/}
                    <FlexGrow className="w-12">
                      <EllipsisTextColumn>
                      {teacher.approval === 1 ?
                        teacher.class_name_list.map((className, index) => (
                          <span key={index}>
                            {className}
                            {index < teacher.class_name_list.length - 1 && ',  '}
                          </span>
                        ))
                        :
                        <span key={index}>
                          {teacher.temp_class_name}
                        </span>
                      }
                      </EllipsisTextColumn>
                    </FlexGrow>
                    <div className="w-12">{teacher.phone ? aesCBCDecrypt(teacher.phone) : ""}</div>
                    <div className="w-20 flex-end">
                      <span style={{fontWeight: 'bold'}} className={approvalColor}>{approvalText}</span>

                      {teacher.approval === 0 ? 
                        <>
                          <SolidPrimarySubBtn className="little-btn" onClick={() => { updateApproval(teacher.id, 1) }}>
                              승인
                          </SolidPrimarySubBtn>
                          <SolidRedBtn className="little-btn" onClick={() => {updateApproval(teacher.id, 2)}}>
                              거절
                          </SolidRedBtn>
                        </>
                        :
                        //이미 승인 완료된 상태라면 버튼 비활성화
                        <>
                          <OutlinePrimaryBtn className="little-btn" onClick={() => { changeRequestTeacherHandler(teacher); openModal('updateTeacher') }}>
                              수정
                          </OutlinePrimaryBtn>
                          <SolidRedBtn className="little-btn" onClick={() => { handleDeleteTeacher(teacher.id); }}>
                              삭제
                          </SolidRedBtn>
                        </>
                      }
                    </div>
                  </TableColumn>
                )
            })}
            </div>
          </div>
        </div>
      </ListContentWrap>
    )
}

export const TeacherManagement = () => {

  const selectSiteId = useRecoilValue(selectSiteIdState);

  const [loading, setLoading] = useState<boolean>(true);

  //선생님 목록
  const [teacherList, setTeacherList] = useState<UserInfo[]>([]);

  //승인대기 건수
  const [waitApproval, setWaitApproval] = useState(0);

  //모든 선생님 ID 체크박스
  const [allSelectTeacherCheck, setAllSelectTeacherCheck] = useState<boolean>(false);

  //목록 선생님 ID 체크박스
  const [selectTeacherIdList, setSelectTeacherIdList] = useState<number[]>([]);

  //반 선택 옵션
  const [classSelectOption, setClassSelectOption] = useState<provinceInfo[]>([]);

  //수정, 삭제 클릭 시 userId 저장
  const [selectUserId, setSelectUserId] = useState<number>(0);
  //수정 시 teacher의 image_url 저장
  const [selectUserImageUrl, setSelectUserImageUrl] = useState<string>("");

  const defaultRequestTeacher: UserPostType = {
    user_site_list: [{
      site_id: selectSiteId,
      approval: 1,
    }],
    name: "", // 암호화 필요
    email: "", // 암호화 필요
    phone: "", // 암호화 필요
    role: "ROLE_TEACHER", // 사용자 권한 (ROLE_DIRECTOR, ROLE_TEACHER, ROLE_PARENT만 유효)
    login_id: "",
    login_pw: "", // 암호화 필요
    temp_phone: "", // 암호화 필요
    terms_agree: 0, // 0: 미동의, 1: 동의
    unique_code: "", // 사용자 고유 코드 (단말기 사번)
    card_no: "",
    class_id: 0, // ROLE_TEACHER(선생님)인 경우 유효, 이외 0으로 설정
    student_id: 0, // ROLE_PARENT(학부모)인 경우 유효, 이외 0으로 설정
    temp_mobile_os: 0, // 1: Android, 2: IOS (회원 가입시 승인 push발송을 위한 모바일 OS) (web은 해당 없음)
    temp_mobile_token: "", // 회원 가입시 승인 push 발송을 위한 임시 토큰 (web은 해당 없음)
    base64_list: [],
  };

  //사용자 등록 시
  const [requestTeacher, setRequestTecher] = useState<UserPostType>(defaultRequestTeacher);

  //일괄 승인 클릭 여부 - 선생님 목록 새로고침용
  const [isUpdateAllApproval, setIsUpdateAllApproval] = useState(false);

  //모달 오픈 시 requestTeacher 초기화 함수
  const initRequestTeacher = () => {
    setRequestTecher(defaultRequestTeacher);
  };

  //사용자 API 파라미터
  const [userQueryParams, setUserQueryParams] = useState<UserQueryParams>({
    site_id: selectSiteId,
    name: "",
    page: 1,
    size: 1000,
    class_id: 0,
    role: ROLE_TEACHER,
    role_number: 0,
    student_name: "",
  });

  const imageInput = useRef<HTMLInputElement>(null);

  //모달 상태
  const [modalProps, setModalProps] = useState<ModalPropsInterface>({
    isOpen: false,
    isClose: () => {},
    title: "",
    content: null,
    button: null,
    type: ""
  });

  //반 등록/수정 모달 열기 버튼 클릭 시
  const openModal = (modalType:ModalType) => {
    let title: ModalTitle = "";
    let content:JSX.Element = <></>;
    let button:JSX.Element = <></>;
    switch (modalType) {
      case "createTeacher":
        title = "선생님 신규 등록";
        break;
      case "updateTeacher":
        title = "선생님 정보 수정";
        break;
    }

    setModalProps({
      isOpen: true,
      isClose: () => setModalProps({...modalProps, isOpen: false}),
      title: title,
      content: content,
      button: button,
      type: modalType
    });
  }

  //선생님 수정,삭제 클릭 시 requestUser 업데이트
  const changeRequestTeacherHandler = async (teacher: UserInfo) => {
    setSelectUserId(teacher.id);
    setSelectUserImageUrl(teacher.image_url);
    setRequestTecher({
      user_site_list: teacher.user_site_list,
      name: aesCBCDecrypt(teacher.name),
      email: teacher.email ? aesCBCDecrypt(teacher.email) : "",
      phone: teacher.phone ? aesCBCDecrypt(teacher.phone) : "",
      role: teacher.role,
      login_id: teacher.login_id,
      temp_phone: teacher.temp_phone ? aesCBCDecrypt(teacher.temp_phone) : "",
      terms_agree: teacher.terms_agree,
      unique_code: teacher.unique_code,
      card_no: teacher.card_no,
      base64_list: [],
      //선생님의 첫번째 담당 반 ID 설정
      class_id: await getFirstClassId(teacher.id),
    })
  }

  /**
   * 선생님 등록 모달 컨텐츠
   * @constructor
   */
  const TeacherModalContent = ():JSX.Element => {

    //선생님 등록 정보 업데이트
    function updateRequestUser(updates: Partial<UserPostType>) {
      setRequestTecher({
        ...requestTeacher,
        ...updates,
      });
    }

    const setBase64Image = (base64: string) => {
      //이미지는 1개만 등록할수 있게, 배열 초기화 후 추가
      setRequestTecher({
        ...requestTeacher,
        base64_list: [...[], base64]
      });
    };

    //input 값 변경 이벤트
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = e.target;
      updateRequestUser({ [name]: value }); // 상태 업데이트
    };

    //select 값 변경 이벤트
    const handleInputChangeSelect = (value:number) => {
      updateRequestUser({class_id:value});
    }

    //이미지 파일 변경 이벤트
    const onImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
      const base64Files:string[]|undefined = await handleImageUpload(event);
      if (base64Files && base64Files.length > 0) {
        setBase64Image(base64Files[0]);
      }
    };

    // 파일 선택 - input 클릭 시(사진)
    const handleImageFileClick = (e: any) => {
      imageInput.current?.click();
    };

    //클래스 선택 옵션 깊은 복사
    const classSelectOptionsCopy = JSON.parse(JSON.stringify(classSelectOption));

    //전체 문구를 미지정으로 변경
    if (classSelectOptionsCopy.length > 0) {
      classSelectOptionsCopy[0].label = "미지정";
    }
    else {
      classSelectOptionsCopy.push({label: "미지정", value: 0});
    }

    //이미지 소스
    let imageSrc;
    //수정 모달이고, 기존 이미지가 있을때
    if(modalProps.type === "updateTeacher" && selectUserImageUrl && requestTeacher.base64_list.length === 0){
      imageSrc = selectUserImageUrl;
    }
    //이미지 업로드가 있을때
    else if(requestTeacher.base64_list.length > 0){
      imageSrc = requestTeacher.base64_list[0];
    }
    else{
      imageSrc = DefaultProfileS;
    }

    return (
      <>
        <RowContentWrap>
          <RowContentLeftWrap>
            <div className="file-wrap">
              <ImageOneWrap onClick={handleImageFileClick}>
                <img className="preview-image" srcSet={imageSrc} alt="preview"/>
                <img className="carema-icon" src="/image/icon/camera-background.svg" alt="camera"/>
                <input
                  type="file"
                  name="file"
                  onChange={(e) => onImageChange(e)}
                  accept=".jpg, .png, .jpeg"
                  style={{display: "none"}}
                  ref={imageInput}
                  multiple
                />
              </ImageOneWrap>
            </div>
          </RowContentLeftWrap>

          <RowContentRightWrap>
            <InputWrapR>
              <InputWrapC>
                <label className="required_value">이름</label>
                <input type="text" name="name" value={requestTeacher.name} onChange={handleInputChange}
                      placeholder="선생님 이름 입력"/>
              </InputWrapC>
            </InputWrapR>

            <InputWrapR>
              <InputWrapC>
                <label className="required_value">로그인 아이디</label>
                <input type="text" name="login_id" value={requestTeacher.login_id} onChange={handleInputChange}
                      placeholder="아이디 입력" disabled={modalProps.type === "updateTeacher"} />
              </InputWrapC>
            </InputWrapR>
            {
              //선생님 등록 모달일때만 비밀번호 입력
              modalProps.type === "createTeacher" &&
              <InputWrapR>
                <InputWrapC>
                  <label className="required_value">로그인 비밀번호</label>
                  <input type="password" name="login_pw" value={requestTeacher.login_pw} onChange={handleInputChange}
                        placeholder="비밀번호 입력"/>
                </InputWrapC>
              </InputWrapR>
            }

            <InputWrapR>
              <InputWrapC>
                <label>이메일 주소</label>
                <input type="text" name="email" value={requestTeacher.email} onChange={handleInputChange}
                      placeholder="이메일 주소 입력"/>
              </InputWrapC>
            </InputWrapR>

            <InputWrapR>
              <InputWrapC>
                <label className="required_value">연락처('-'없이 숫자만)</label>
                <input type="text" name="phone" value={requestTeacher.phone} onChange={handleInputChange}
                    placeholder="연락처 입력('-'없이 숫자만 입력)" disabled={modalProps.type === "updateTeacher"} />
              </InputWrapC>
            </InputWrapR>

            <InputWrapR>
              <InputWrapC>
                <label>담당 반 지정</label>
                <SelectOption optionData={classSelectOptionsCopy}
                              defaultValue={requestTeacher.class_id}
                              dontChange={modalProps.type === "updateTeacher"}
                              onChange={(class_id: number) => { handleInputChangeSelect(class_id) }} />
                {modalProps.type === "updateTeacher" &&
                  <p style={{padding: '0.25rem 1rem', color: `${colors.yellow}`}}>담당 반 수정은 [반 관리] 메뉴에서 진행해주세요.</p>
                }
              </InputWrapC>
            </InputWrapR>
          </RowContentRightWrap>
        </RowContentWrap>
      </>
    )
  }

  //선생님 삭제 API 호출
  const handleDeleteTeacher = async (userId:number):Promise<void> => {

    const confirm:boolean = window.confirm("선생님을 삭제하시겠습니까?");
    if(!confirm){
      return;
    }

    const res:CommonResult = await deleteUserHandler(userId);
    if(res.code === 200){
      alert("선생님 삭제가 완료되었습니다.");
      getTeacherList();
      setModalProps({...modalProps, isOpen: false});
    }
    else{
      alert(res.message);
    }
  }

  /**
   * 선생님 등록 모달 컨텐츠
   * @constructor
   */
  const TeacherModalButton = ():JSX.Element => {

    //요청 데이터 유효성 검사
    const validateRequestTeacher = ():void => {
        
      if(!requestTeacher.name){
        alert("이름을 입력해주세요.");
        return;
      }

      if(!checkName(requestTeacher.name)){
        alert("공백 없이 정확한 이름을 입력해주세요.");
        return;
      }

      if(!requestTeacher.login_id){
        alert("로그인 아이디를 입력해주세요.");
        return;
      }

      if(!checkId(requestTeacher.login_id)){
        alert("로그인 아이디는 대/소문자/숫자만 입력 가능합니다.");
        return;
      }

      //등록일때만 해당
      if(!requestTeacher.login_pw && modalProps.type === "createTeacher"){
        alert("로그인 비밀번호를 입력해주세요.");
        return;
      }

      if (requestTeacher.phone && !checkMobile(requestTeacher.phone)) {
        alert('정확한 연락처를 입력해주세요');
        return;
      }

      try {
        //requestTeacher 객체 복사
        const requestTeacherCopy = { ...requestTeacher };

        //이름, 비밀번호, 이메일, 연락처, 암호화
        if(requestTeacherCopy.name){
          requestTeacherCopy.name = aesCBCEncrypt(requestTeacherCopy.name);
        }

        if(requestTeacherCopy.login_pw){
          requestTeacherCopy.login_pw = aesCBCEncrypt(requestTeacherCopy.login_pw);
        }

        if(requestTeacherCopy.email){
          requestTeacherCopy.email = aesCBCEncrypt(requestTeacherCopy.email);
        }

        if(requestTeacherCopy.phone){
          requestTeacherCopy.phone = aesCBCEncrypt(requestTeacherCopy.phone);
        }

        if(requestTeacherCopy.temp_phone){
          requestTeacherCopy.temp_phone = aesCBCEncrypt(requestTeacherCopy.temp_phone);
        }

        modalProps.type === "createTeacher" ? handleCreateTeacher(requestTeacherCopy) : handleUpdateTeacher(requestTeacherCopy);

      }
      catch (e) {
        console.error(e);
      }

    }

    //선생님 수정 API 호출
    const handleUpdateTeacher = async(requestTeacherCopy:UserPostType):Promise<void>=> {
      const res:CommonResult = await updateUserHandler(selectUserId, requestTeacherCopy);
      if(res.code === 200){
        alert("선생님 수정이 완료되었습니다.");
        getTeacherList();
        setModalProps({...modalProps, isOpen: false});
      }
      else if(res.code === 409){
        alert(`${res.message} 로그인 아이디 또는 연락처를 다시 확인해주세요.`);
      }
      else {
        alert(res.message);
      }
    }

    //선생님 등록 API 호출
    const handleCreateTeacher = async(requestTeacherCopy:UserPostType):Promise<void>=> {
      const res:CommonResult = await createUserHandler(requestTeacherCopy);
      if (res.code === 200) {
        alert("선생님 등록이 완료되었습니다.");
        getTeacherList();
        setModalProps({...modalProps, isOpen: false});
      }
      else if(res.code === 409){
        alert(`${res.message} 로그인 아이디 또는 연락처를 다시 확인해주세요.`);
      }
      else {
        alert(res.message);
      }
    }

    return (
      <>
        { modalProps.type === "createTeacher" ?
          <SolidPrimaryBtn onClick={validateRequestTeacher}>등록 완료</SolidPrimaryBtn>
          : <SolidPrimaryBtn onClick={validateRequestTeacher}>수정 완료</SolidPrimaryBtn>
        }
      </>
    )
  }

  /**
   * 선생님 목록 조회
   */
  const getTeacherList = async () => {

    try {

      const res:ListResult<UserInfo> = await getUser(userQueryParams);

      if(res.code === 200){

        const teacherList: UserInfo[] = res.data;

        let cnt = 0; // 승인대기 cnt
        //user_site_list에서 selectSiteId와 일치하는 approval(승인 여부)를 approval로 변경
        for (const teacher of teacherList) {
          const userSite:UserSiteInfo|undefined = teacher.user_site_list.find((userSite) => userSite.site_id === selectSiteId);
          const approval = userSite?.approval;
          const approvalDate = userSite?.approval_date;
          teacher.approval = approval || 0;
          teacher.approval_date = approvalDate || "";

          if (!approval) cnt += 1;

          //담당 반 이름 조회
          teacher.class_name_list = await fetchClassName(teacher.id);
        }

        //모든 선생님 이미지 URL 조회
        setTeacherList(await getUserImageUrl(teacherList));
        
        setWaitApproval(cnt);

        setLoading(false);
      }
    }
    catch (e) {
      console.error(e);
    }
  }
  /**
   * 선생님이 담당하는 반 이름 조회
   * @param userId
   */
  const fetchClassName = async (userId:number):Promise<string[]> => {
    const classList:string[] = [];
    const requestClassParams:ClassQueryParams = {
      response_format:"",
      name:"",
      user_id:userId,
      page: 1,
      size: 1000
    }

    const res:ListResult<ClassInfo> = await getClass(requestClassParams);
    if(res.code === 200){
        classList.push(...res.data.map((classInfo: ClassInfo) => classInfo.name));
    }
    return classList;
  }

  //선생님이 담당하는 첫번째 반 ID 조회
  const getFirstClassId = async (userId:number):Promise<number> => {
    const requestClassParams:ClassQueryParams = {
      response_format:"",
      name:"",
      user_id:userId,
      page: 1,
      size: 1
    }

    const res:ListResult<ClassInfo> = await getClass(requestClassParams);
    if (res.code === 200) {
      return res.data.length ? res.data[0].id : 0;
    }
    return 0;
  }

  /**
   * 단일 승인 요청
   * @param teacherId
   * @param approval
   */
  const updateApproval = async (teacherId:number,approval:number) => {
    try {
      const res:CommonResult = await userApproval(teacherId,approval);
      if(res.code === 200) {
        let title = "승인이 완료되었습니다.";
        if(approval === 2){
          title = "승인이 거절되었습니다.";
        }

        alert(title);
        getTeacherList();
      }
    }
    catch (e) {
      console.error(e);
    }
  };

  const handleSelectTeacherId = (teacherId:number) => {
    //이미 체크된 선생님 ID라면 체크 해제
    if(selectTeacherIdList.includes(teacherId)){
      setSelectTeacherIdList(selectTeacherIdList.filter((id) => id !== teacherId));
    }
    //체크되지 않은 선생님 ID라면 체크
    else{
      setSelectTeacherIdList([...selectTeacherIdList, teacherId]);
    }
  }

  //모든 선생님 체크
  const handleAllSelectTeacherId = () => {
    //모든 선생님 체크 해제
    if(selectTeacherIdList.length === teacherList.length){
      setSelectTeacherIdList([]);
    }
    //모든 선생님 체크
    else{
      const teacherIdList = teacherList.map((teacher) => teacher.id);
      setSelectTeacherIdList(teacherIdList);
    }
  }

  //사용자 검색 조건 변경
  function changeUserQueryParams(updates: Partial<UserQueryParams>) {
    setUserQueryParams({
      ...userQueryParams,
      ...updates,
    });
  }

  //선생님 이름 검색 변경
  function handleTeacherNameSearch(name: string) {
    if(!name){
      changeUserQueryParams({name:""});
      return;
    }
    //선생님 이름 암호화
    changeUserQueryParams({name:aesCBCEncrypt(name)});
  }

  //반 선택 옵션 변경
  function handleClassSelectOptions(class_id: number) {
    changeUserQueryParams({class_id:class_id});
  }

  // 반 출결 전체 불러오기
  const getClassAll = async () => {

    try {

      const classQueryParams: ClassQueryParams = {
        name: "",
        user_id: 0,
        response_format: "",
        page: 1,
        size: 99999999
      };

      //클래스 조회
      const classResult: ListResult<ClassInfo> = await getClass(classQueryParams);

      if (classResult.code === 200) {
        // class는 select-option만 필요함
        const option = formattedSelectOption(classResult.data.map(d => ({
          label: d.name,
          value: d.id
        })));
        setClassSelectOption(option);
      }
      else setClassSelectOption([]);

    }
    catch (error) {
      console.error("get class api error ", error);
    }
  };
  
  useEffect(() => {
    getTeacherList();
    getClassAll();
  }, []);

  useEffect(() => {
    if (isUpdateAllApproval) {
      getTeacherList();
      setIsUpdateAllApproval(false);
      setAllSelectTeacherCheck(false);
      setSelectTeacherIdList([]);
    }
    else return;
  }, [isUpdateAllApproval]);

  return (
    loading ? <Loading /> : (
      <>
        <PageHeaderTitleButtonStyle>
          <p className="header-title">선생님 관리</p>
          <div className="button-wrap">
            <SolidPrimaryBtn onClick={() => {openModal('createTeacher');initRequestTeacher();}}>
              선생님 등록
            </SolidPrimaryBtn>
          </div>
        </PageHeaderTitleButtonStyle>
        <PageArticleWrap>
          <nav className="filter-container">
            <div className="filter-wrap">
              <label style={{minWidth: '3rem'}}>담당 반</label>
              <SelectOption optionData={classSelectOption}
                            defaultValue={userQueryParams.class_id}
                            onChange={(class_id:number) => {handleClassSelectOptions(class_id)}}/>
            </div>
            <div className="filter-wrap">
              <label style={{minWidth: '3rem'}}>선생님 이름</label>
              <input type="text"
                    placeholder="선생님 이름을 입력하세요."
                    // value={aesCBCDecrypt(userQueryParams.name)}
                    onChange={(e) => {handleTeacherNameSearch(e.target.value)}}
                    onKeyDown={(e) => {
                      if(e.key === 'Enter'){
                        getTeacherList();
                      }
                    }}/>
            </div>
            <SolidPrimarySubBtn onClick={getTeacherList}>조회</SolidPrimarySubBtn>
          </nav>

          <article className="list-content-container">
            <div className="article-header">
              <p><span className="article-header-title">선생님 목록</span></p>
            </div>
            {teacherList.length === 0 ? (
              <NoDataWrap>
                <NoDataWithImageText text={NoTeacherDataText}/>
              </NoDataWrap>
            ):(
              <TeacherListViewer teacherList={teacherList}
                                  setIsUpdateAllApproval={setIsUpdateAllApproval}
                                  waitApproval={waitApproval}
                                  allSelectTeacherCheck={allSelectTeacherCheck}
                                  selectTeacherIdList={selectTeacherIdList}
                                  setAllSelectTeacherCheck={setAllSelectTeacherCheck}
                                  handleSelectTeacherId={handleSelectTeacherId}
                                  handleAllSelectTeacherId={handleAllSelectTeacherId}
                                  updateApproval={updateApproval}
                                  changeRequestTeacherHandler={changeRequestTeacherHandler}
                                  openModal={openModal}
                                  handleDeleteTeacher={handleDeleteTeacher}/>
            )}
          </article>
        </PageArticleWrap>
        {/*content에 렌더링할 컴포넌트를 전달하여 최신 상태로 리렌더링*/}
        <DefaultModalComponent isOpen={modalProps.isOpen}
                                content={TeacherModalContent()}
                                button={TeacherModalButton()}
                                type={modalProps.type}
                                isClose={modalProps.isClose}
                                title={modalProps.title} />
      </>
    )
  )
}